import { render, staticRenderFns } from "./CommodityClients.vue?vue&type=template&id=676c59d2&"
import script from "./CommodityClients.vue?vue&type=script&lang=js&"
export * from "./CommodityClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports